import { withSvgIconSimple } from './withSvgIconSimple';

export const Success = withSvgIconSimple(
  <>
    <circle cx="14" cy="14" r="11" stroke="currentColor" strokeWidth="2.3" />
    <path
      d="M9.56338 15.3688L13.1652 18.2502L18.2076 10.3263"
      stroke="currentColor"
      strokeWidth="2.3"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 28 28' },
);
